<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> بررسی و تایید کارکرد رانندگان </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <form class="row gx-2 gy-md-0 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" class="form-control text-end" placeholder="از تاریخ" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strEDate" class="form-control text-end" placeholder="تا تاریخ" />

            </ng-persian-datepicker>

        </div>

        <!-- نام راننده -->

        <div *ngIf="list_Drivers.length > 0" class="col-12 col-md-3 position-relative">

            <label> نام راننده </label>

            <custom-filter *ngIf="list_Drivers.length > 0"
                [strValue]="returnStrValue('strFullName',mdl_Search.get('strFullName')?.value,list_Drivers,'strFullName')"
                [strComment]="'strFullName'" [stylesArray]="['padding-top: 6px']"
                [str_Placeholder]="'نام راننده را جستجو کنید'" [lst_Main]="list_Drivers"
                [lst_SearchKey]="['strFullName']" [isDisabled]="false" (hideOptions)="selectedDriver($event)">

            </custom-filter>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-primary w-100" (click)="getResult()">

                <small class="">

                    &nbsp; جستجو &nbsp;

                </small>

            </button>

        </div>

        <!--  -->

        <div class="col-12 mb-3">

            <div class="mt-3" *ngIf="mdl_Search.get('strUnitID')?.value">

                <span class="mx-2"> نام راننده : <small class="text-primary"> {{ mdl_Search.get('strFullName')?.value }}
                    </small> </span>

                <span class="mx-2"> کد پرسنلی : <small class="text-primary"> {{ mdl_Search.get('strPersonnelID')?.value
                        |
                        faNum }} </small> </span>

                <span class="mx-2"> واحد سازمانی : <small class="text-primary"> {{
                        mdl_Search.get('strMobileDomain')?.value | faNum }} </small> </span>

                <p class="d-none mt-3 mb-1">

                    <span class="mx-2"> حقوق : <small> {{ 0 | faNum }} </small> </span>

                    <span class="mx-2"> اضافه کاری : <small> {{ 0 | faNum }} </small> </span>

                    <span class="mx-2"> شناور : <small> {{ 0 | faNum }} </small> </span>

                    <span class="mx-2"> ماموریت : <small> {{ 0 | faNum }} </small> </span>

                    <span class="mx-2"> حقوق کل : <small> {{ 0 | faNum }} </small> </span>

                    <span class="mx-2"> تعداد سفر : <small> {{ 0 | faNum }} </small> </span>


                </p>

            </div>

        </div>

        <!-- ویرایش کلی -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-primary w-100" (click)="open_FullEdit()">

                <small class="">

                    &nbsp; ویرایش کلی &nbsp;

                </small>

            </button>

        </div>

        <!-- محاسبه مجدد -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-secondary w-100" (click)="reCalculate()">

                <small class="">

                    &nbsp; محاسبه مجدد &nbsp;

                </small>

            </button>

        </div>

        <!-- انتقال اطلاعات بهره بردار -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-secondary w-100" (click)="openTransfer()">

                <small class="">

                    &nbsp; انتقال اطلاعات بهره بردار &nbsp;

                </small>

            </button>

        </div>

        <!-- تایید نهایی -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-success w-100" (click)="finalApproval()">

                <small class="">

                    &nbsp; تایید نهایی &nbsp;

                </small>

            </button>

        </div>

        <!-- انتقال مقادیر به فیش حقوقی -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-secondary w-100" (click)="transfer2PaySlip()">

                <small class="">

                    &nbsp; انتقال مقادیر به فیش حقوقی &nbsp;

                </small>

            </button>

        </div>

        <!-- بارگذاری از اکسل -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-success w-100">

                <small class="">

                    &nbsp; بارگذاری از اکسل &nbsp;

                </small>

            </button>

        </div>

        <!-- حذف گروهی -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-danger w-100">

                <small class="">

                    &nbsp; حذف گروهی &nbsp;

                </small>

            </button>

        </div>

        <!-- چاپ -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-secondary w-100" printSectionId="print-table" [useExistingCss]="true" ngxPrint printTitle="بررسی و تایید کارکرد رانندگان">

                <small class="">

                    &nbsp; چاپ &nbsp;

                </small>

            </button>

        </div>


    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-2 gy-md-0 gy-3">

            <!-- اینپوت جستجو -->

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="max-height:calc(100vh - 320px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th *ngFor="let item of lst_Headers" class="text-center"
                            (click)="item.checkbox ? selectAll() : ''">

                            {{ item.strName }}

                        </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Result; let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td> <input type="checkbox" class="pointer" (change)="setCheckBox($event.target.checked,item)"
                                [checked]="isSelected(item.iAttendanceDriver)">

                        </td>

                        <td class="">

                            <i class="fa fa-edit fa-lg text-primary mx-2 pointer" title=" ویرایش"
                                (click)="open_Edit(item,i)"></i>

                            <i class="fa fa-trash fa-lg text-danger pointer" title="حذف"
                                (click)="removeItem(item,i)"></i>

                        </td>

                        <td> {{ item.strStatus | faNum }} </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strDayName | faNum }} </td>

                        <td> {{ item.strHolidy | faNum }} </td>

                        <td> {{ item.iSalary.toLocaleString() | faNum }} </td>

                        <td> {{ item.iSalaryTemp.toLocaleString() | faNum }} </td>

                        <td> {{ item.iSalaryFloat.toLocaleString() | faNum }} </td>

                        <td> {{ item.iSalaryMission.toLocaleString() | faNum }} </td>

                        <td> {{ item.iSalaryTotal.toLocaleString() | faNum }} </td>

                        <td> {{ item.strStartTime | faNum }} </td>

                        <td class="bg-light"> {{ item.strStartTime_ | faNum }} </td>

                        <td> {{ item.strEndTime | faNum }} </td>

                        <td class="bg-light"> {{ item.strEndTime_ | faNum }} </td>

                        <td> {{ item.strPresentTime | faNum }} </td>

                        <td> {{ item.strMoveTime | faNum }} </td>

                        <td> {{ item.strOvertime | faNum }} </td>

                        <td> {{ item.fKmMission | faNum }} </td>

                        <td class="bg-light"> {{ item.fKmMission_ | faNum }} </td>

                        <td> {{ item.fKm | faNum }} </td>

                        <td class="bg-light"> {{ item.fKm_ | faNum }} </td>

                        <td> {{ item.fKmTotal | faNum }} </td>

                        <td> {{ item.tiTripCount | faNum }} </td>

                        <td class="bg-light"> {{ item.tiTripCount_ | faNum }} </td>

                        <td> {{ item.iFloatingTripCount | faNum }} </td>

                        <td> {{ item.tiEncourageTrip | faNum }} </td>

                    </tr>

                </tbody>

                <tfoot>
                    <tr class="col-12 text-center table-total-row bg-light-2">
                        <th colspan="X"> مجموع </th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="fw-bold"> {{ total_iSalary.toLocaleString() | faNum }} </td>
                        <td class="fw-bold"> {{ total_iSalaryTemp.toLocaleString() | faNum }} </td>
                        <td class="fw-bold"> {{ total_iSalaryFloat.toLocaleString() | faNum }} </td>
                        <td class="fw-bold"> {{ total_iSalaryMission.toLocaleString() | faNum }} </td>
                        <td class="fw-bold"> {{ total_iSalaryTotal.toLocaleString() | faNum }} </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="fw-bold"> {{ total_tiTripCount.toLocaleString() | faNum }} </td>
                        <td></td>
                        <td></td>
                        <td></td>

                    </tr>

                </tfoot>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="EditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> ویرایش کارکرد </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Edit" class="row gx-0 gy-3">

                    <!-- ساعت شروع -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت شروع </label>

                        <div class="input-group clockpicker">

                            <input type="text" class="form-control p-2 text-center" id="strStartTime_"
                                formControlName="strStartTime_">

                            <span class="input-group-addon">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                    <!-- ساعت پایان -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت پایان </label>

                        <div class="input-group clockpicker">

                            <input type="text" class="form-control p-2 text-center" id="strEndTime_"
                                formControlName="strEndTime_">

                            <span class="input-group-addon">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                    <!-- کیلومتر شهری  -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> کیلومتر شهری </label>

                        <input class="form-control p-2 text-center" formControlName="fKm_">

                    </div>

                    <!-- کیلومتر ماموریت   -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> کیلومتر ماموریت </label>

                        <input class="form-control p-2 text-center" formControlName="fKmMission_">

                    </div>

                    <!-- تعداد سفر  -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> تعداد سفر </label>

                        <input class="form-control p-2 text-center" formControlName="tiTripCount_">

                    </div>

                    <!-- سفر تشویقی  -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> سفر تشویقی </label>

                        <input class="form-control p-2 text-center" formControlName="tiEncourageTrip">

                    </div>


                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="submit_Edit()">

                    &nbsp; ویرایش &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="FullEditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> ویرایش کلی </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_FullEdit" class="row gx-md-2 gx-0 gy-3 px-2">

                    <!--  -->

                    <div class="col-6 form-check">

                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                            formControlName="bStartTime">

                        <label class="form-check-label" for="flexCheckDefault">

                            ویرایش ساعت شروع

                        </label>

                    </div>

                    <!--  -->

                    <div class="col-6 form-check">

                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                            formControlName="bEndTime">

                        <label class="form-check-label" for="flexCheckChecked">

                            ویرایش ساعت پایان

                        </label>

                    </div>

                    <!-- ساعت شروع -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت شروع </label>

                        <div class="input-group clockpicker">

                            <input type="text" class="form-control p-2 text-center" id="strStartTime2_"
                                formControlName="strStartTime_">

                            <span class="input-group-addon">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                    <!-- ساعت پایان -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت پایان </label>

                        <div class="input-group clockpicker">

                            <input type="text" class="form-control p-2 text-center" id="strEndTime2_"
                                formControlName="strEndTime_">

                            <span class="input-group-addon">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="submit_FullEdit()">

                    &nbsp; ویرایش &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="TransferModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> انتقال اطلاعات بهره بردار </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Transfer" class="row gx-md-2 gx-0 gy-3 px-2">

                    <!--  ساعت شروع -->

                    <div class="col-6 form-check">

                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                            formControlName="bStartTime">

                        <label class="form-check-label" for="flexCheckDefault">

                            ساعت شروع

                        </label>

                    </div>

                    <!-- ساعت پایان -->

                    <div class="col-6 form-check">

                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                            formControlName="bEndTime">

                        <label class="form-check-label" for="flexCheckChecked">

                            ساعت پایان

                        </label>

                    </div>

                    <!-- کیلومتر شهری -->

                    <div class="col-6 form-check">

                        <input class="form-check-input" type="checkbox" value="" id="bfKm" formControlName="bfKm">

                        <label class="form-check-label" for="bfKm">

                            کیلومتر شهری

                        </label>

                    </div>

                    <!-- کیلومتر ماموریتی -->

                    <div class="col-6 form-check">

                        <input class="form-check-input" type="checkbox" value="" id="bfkmMission"
                            formControlName="bfkmMission">

                        <label class="form-check-label" for="bfkmMission">

                            کیلومتر ماموریتی

                        </label>

                    </div>

                    <!-- تعداد سفر -->

                    <div class="col-6 form-check">

                        <input class="form-check-input" type="checkbox" value="" id="bTitripCount"
                            formControlName="bTitripCount">

                        <label class="form-check-label" for="bTitripCount">

                            تعداد سفر

                        </label>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="submit_Transfer()">

                    &nbsp; ویرایش &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- پرینت -->

<div class="section border border-2 mt-2" id="print-table">

    <div class="col-12" style="direction: rtl;">

        <p class="">

            <span class="fw-bold text-muted"> گزارش عملکرد راننده : </span>

            <span class="text-primary"> {{ mdl_Search.get('strFullName')?.value }} / </span>

            <span class="text-primary"> {{ mdl_Search.get('strPersonnelID')?.value | faNum }} </span>

        </p>

        <p class="">

            <span class="fw-bold text-muted"> از تاریخ : </span>

            <span class="text-primary"> {{ mdl_Search.get('strSDate')?.value | faNum }} </span>

            <span class="fw-bold text-muted mx-2"> تا تاریخ : </span>

            <span class="text-primary"> {{ mdl_Search.get('strEDate')?.value | faNum }} </span>

        </p>

    </div>

    <table class="col-12 table table-striped rounded-3" id="Export_Excel" style="direction: rtl;">

        <thead>

            <tr class="">

                <th *ngFor="let item of lst_HeadersPrint" class="text-center">

                    {{ item.strName }}

                </th>

            </tr>

        </thead>

        <tbody>

            <tr class="col-12 text-center" *ngFor="let item of list_Result; let i = index">

                <th> {{ i + 1 | faNum }} </th>

                <td> {{ item.strDate | faNum }} </td>

                <td> {{ item.strDayName | faNum }} </td>

                <td> {{ item.strStartTime | faNum }} </td>

                <td> {{ item.strEndTime | faNum }} </td>

                <td> {{ item.fKm.toLocaleString() | faNum }} </td>
                
                <td> {{ item.fKmMission.toLocaleString() | faNum }} </td>
                
                <td> {{ item.tiTripCount | faNum }} </td>

                <td> {{ item.iSalaryTotal.toLocaleString() | faNum }} </td>

                <td> {{ item.iSalaryTemp.toLocaleString() | faNum }} </td>

                <td> {{ item.iSalaryFloat.toLocaleString() | faNum }} </td>

                <td> {{ item.iSalaryMission.toLocaleString() | faNum }} </td>

            </tr>

        </tbody>

        <tfoot>
            <tr class="col-12 text-center table-total-row bg-light-2">
                <th colspan="X"> مجموع </th>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="fw-bold"> {{ total_tiTripCount.toLocaleString() | faNum }} </td>
                <td class="fw-bold"> {{ total_iSalaryTotal.toLocaleString() | faNum }} </td>
                <td class="fw-bold"> {{ total_iSalaryTemp.toLocaleString() | faNum }} </td>
                <td class="fw-bold"> {{ total_iSalaryFloat.toLocaleString() | faNum }} </td>
                <td class="fw-bold"> {{ total_iSalaryMission.toLocaleString() | faNum }} </td>
            </tr>

        </tfoot>

    </table>

</div>